/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import {css, SerializedStyles} from '@emotion/react';

const LabelWrapper = styled('label')`
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
`;

const CheckboxInput = styled('input')`
  opacity: 0;
  width: 0;
  height: 0;
`;

const ToggleSpan = styled('span')`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 17px;
  box-shadow: 1px 3px 9px 0 #00000040;

  &:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    //left: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
  }

  input:checked + & {
    &:before {
      transform: translateX(15px);
    }
  }
`;


type Props ={
  isOn: boolean;
  onToggle: (value: boolean) => void;
  title?: string;
  disable?: boolean;
  onColor?: string;
  offColor?: string;
  rootCss?: SerializedStyles;
  onText?: string;
  offText?: string;
}

export const ToggleSwitchSmall = (props: Props) => {
  const backgroundColors = css`
    background-color: ${props.isOn ? props.onColor : props.offColor};
  `;

  const onChange = (event) => {
    const isOn = event.target.checked;
    props.onToggle?.(isOn);
  };

  return (
    <LabelWrapper css={props.rootCss} title={props.title}>
      <CheckboxInput
        type="checkbox"
        checked={props.isOn}
        disabled={!!props.disable}
        onChange={onChange}
      />
      <ToggleSpan css={backgroundColors}>{props.isOn ? props.onText : props.offText}</ToggleSpan>
    </LabelWrapper>
  );
};

